/**
 * @deprecated since version 0.2309.0
 * Don't use it anymore.
 * Component Recaptcha is now embeded in Widget ContactForm.
 */

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import React, { FC } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ContactUsReCaptcha: FC<WidgetProps> = () => {
    const recaptchaRef: React.RefObject<ReCAPTCHA | null> = React.createRef();
    return <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />;
};

const widgetModule: WidgetModule = {
    component: ContactUsReCaptcha,
    definition: {
        group: "Contact Us",
        displayName: "ReCaptcha",
        icon: "shield",
        fieldDefinitions: [],
    },
};

export default widgetModule;
